
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as menul3XIPgLTv1f1AR_1myIy0ulUz07vBsXG8GcgfVv5LnwMeta } from "/vercel/path0/pages/menu.vue?macro=true";
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as groupsZNhDGUZNTfbGLjGlwqrZTFt19aEkCpVBA_45kHav9NYEUMeta } from "/vercel/path0/pages/groups.vue?macro=true";
import { default as contact6cZoOGxJBTY9l_45DSf37OWQKprIBU1PffJx7PVn14dCsMeta } from "/vercel/path0/pages/contact.vue?macro=true";
import { default as sitemapnpadVI10GvN_45Y_45o1so1bwWJcyYretVyWs_xkYJE7aFUMeta } from "/vercel/path0/pages/sitemap.vue?macro=true";
import { default as _91_46_46_46page_93B6221gClypHIxjPWduJSW1WcqVmtTSAgv2lPPCKtC3oMeta } from "/vercel/path0/pages/[...page].vue?macro=true";
import { default as indexKmjwSzq9GaAAk3Ey8PsdYuMIJhhwCqzoHwjXqVD_YWMMeta } from "/vercel/path0/pages/vacancies/index.vue?macro=true";
import { default as _91item_93hh_00XwaGPAQLiyctzWT0PTXCTH4h86sL6TLOX52aqYMeta } from "/vercel/path0/pages/vacancies/[item].vue?macro=true";
export default [
  {
    name: "menu___nl",
    path: "/menus",
    component: () => import("/vercel/path0/pages/menu.vue")
  },
  {
    name: "menu___en",
    path: "/en/menus",
    component: () => import("/vercel/path0/pages/menu.vue")
  },
  {
    name: "index___nl",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "groups___nl",
    path: "/groepen",
    component: () => import("/vercel/path0/pages/groups.vue")
  },
  {
    name: "groups___en",
    path: "/en/groups",
    component: () => import("/vercel/path0/pages/groups.vue")
  },
  {
    name: "contact___nl",
    path: "/contact",
    component: () => import("/vercel/path0/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    component: () => import("/vercel/path0/pages/contact.vue")
  },
  {
    name: "sitemap___nl",
    path: "/sitemap",
    component: () => import("/vercel/path0/pages/sitemap.vue")
  },
  {
    name: "sitemap___en",
    path: "/en/sitemap",
    component: () => import("/vercel/path0/pages/sitemap.vue")
  },
  {
    name: "page___nl",
    path: "/:page(.*)*",
    component: () => import("/vercel/path0/pages/[...page].vue")
  },
  {
    name: "page___en",
    path: "/en/:page(.*)*",
    component: () => import("/vercel/path0/pages/[...page].vue")
  },
  {
    name: "vacancies___nl",
    path: "/vacatures",
    component: () => import("/vercel/path0/pages/vacancies/index.vue")
  },
  {
    name: "vacancies___en",
    path: "/en/vacancies",
    component: () => import("/vercel/path0/pages/vacancies/index.vue")
  },
  {
    name: "vacancies-item___nl",
    path: "/vacatures/:item()",
    component: () => import("/vercel/path0/pages/vacancies/[item].vue")
  },
  {
    name: "vacancies-item___en",
    path: "/en/vacancies/:item()",
    component: () => import("/vercel/path0/pages/vacancies/[item].vue")
  }
]